import DefaultElementNodeType from '../DefaultElementNodeType';
import {BUSINESS_REPRESENTATION} from '../../metamodel/Concept';

export default class RepresentationNodeType extends DefaultElementNodeType {
	static get typeName() {
		return BUSINESS_REPRESENTATION;
	}
}
